import {createAction} from "@reduxjs/toolkit";

export const setTicketsPageFilter = createAction<{ fromDttm: number, toDttm?: number }>("ui/tickets-page/setFilter");
